/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RasterDto } from '../../models/raster-dto';

export interface UploadRaster$Params {

/**
 * 0-based column for Z value
 */
  zColumn: number;

/**
 * category id
 */
  category: string;
      body?: {
'file': Blob;
}
}

export function uploadRaster(http: HttpClient, rootUrl: string, params: UploadRaster$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterDto>> {
  const rb = new RequestBuilder(rootUrl, uploadRaster.PATH, 'post');
  if (params) {
    rb.query('zColumn', params.zColumn, {});
    rb.query('category', params.category, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RasterDto>;
    })
  );
}

uploadRaster.PATH = '/v1/raster/importRaster';
